import { applyClientLocale } from '@/lib/i18n/client-locale'
import { createClient } from '@/lib/supabase/client'

export async function setUserLocale(locale: string) {
  const response = await fetch('/api/locale', {
    body: JSON.stringify({ locale }),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  })

  if (!response.ok) {
    throw new Error('Failed to update locale')
  }

  // The static shell never re-renders <html lang/dir> server-side; apply the
  // new locale to the live document (callers' router.refresh() re-renders the
  // server-resolved section translations).
  applyClientLocale(locale)

  const supabase = createClient()
  const { error } = await supabase.auth.updateUser({ data: { locale } })
  if (error) {
    console.warn('Locale cookie updated, but user metadata could not be persisted:', error)
  }
}
